// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#add-loss-modal___BV_modal_content_ {\n  min-height: 500px;\n}\n", ""]);
// Exports
module.exports = exports;
